export default () => ({
    intersectRemoveSlow() {
        this.$el.classList.remove('slow')
    },
    intersectRemoveOut() {
        this.$el.classList.remove('out')
    },
    intersectAddOut() {
        this.$el.classList.add('out')
    },
    intersectAddAnimate() {
        this.$el.classList.add('animate')
    }
})
